/** Display name for idea submitter / audit fields. */
export function ideaBoardDisplayName(profile, user) {
  if (profile?.display_name?.trim()) return profile.display_name.trim()
  if (profile?.full_name?.trim()) return profile.full_name.trim()
  const parts = [profile?.first_name, profile?.last_name].filter(Boolean)
  if (parts.length) return parts.join(' ')
  if (profile?.email?.trim()) return profile.email.trim()
  if (user?.email?.trim()) return user.email.trim()
  return 'Unknown'
}
